import React, { useEffect, useRef, useState } from "react";
import DashboardHeader from "../components/Other/DashboardHeader";
import { useOutletContext } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart as empty,
  faBookmark,
} from "@fortawesome/free-regular-svg-icons";
import { faComment as empty2 } from "@fortawesome/free-regular-svg-icons";
import {
  faArrowUpFromBracket,
  faHeart,
  faTrash,
  faEllipsisH,
  faEdit,
  faRepeat,
  faBookmark as saved,
  faBan,
  faFlag,
  faEllipsisV,
  faPlay,
} from "@fortawesome/free-solid-svg-icons";
import {
  deleteComment,
  repostPost,
  addComment,
  likeDislike,
  getComment,
  deletePost,
  savePost,
  getMyPost,
  reportPostApi,
  blockUnblockUserApi,
  getPaidPost,
  undoRepostPost,
} from "../api/user";
import { toast } from "react-toastify";
import { useNavigate, useParams, Link } from "react-router-dom";
import Loader from "../components/Loader";
import PageContainer from "../components/pages/PageContainer";
import InfiniteScroll from "react-infinite-scroll-component";
import SmallLoader from "../components/smallLoader";
import GreenTick from "../images/green-tick.png";
import BlockReportModal from "../components/Modals/blockandreport";
import UndoRepostModal from "../components/Modals/repostModal";
import { PreviewVideo } from "./previewVideo";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const PaidContent = () => {
  const [sidebarToggle] = useOutletContext();
  const navigate = useNavigate();
  const { id } = useParams();
  const [posts, setPosts] = useState([]);
  const [profile, setProfile] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [page, setPage] = useState(2);
  const [hasMore, setHasMore] = useState(true);
  const [commentOpenStates, setCommentOpenStates] = useState({});
  const [newComment, setNewComment] = useState("");
  const [postComments, setPostComments] = useState({});
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [loadMore, setLoadMore] = useState(false);
  const [loginUserId, setLoginUserId] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [showFullDescription, setShowFullDescription] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newid, setNewId] = useState("");
  const [isDataFeteched, setisDataFeteched] = useState(false);
  const [showFullRepostDescription, setShowFullRepostDescription] = useState(
    []
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownStates, setDropdownStates] = useState([]);
  const [isBlockOpen, setIsBlockOpen] = useState(false);
  const [postType, setPostType] = useState("");
  const [blockReportIDs, setBlockReportIDs] = useState("");
  const [reportComment, setReportComment] = useState("");

  const handleBlockUserCancel = () => {
    setIsBlockOpen(false);
    setPostType("");
    setBlockReportIDs("");
  };

  const handleBlockUser = async () => {
    const res = await blockUnblockUserApi({ user_id: blockReportIDs });
    // console.log(res, "res-block");
    if (res?.data?.status == 200) {
      setIsBlockOpen(false);
      setPostType("");
      setBlockReportIDs("");
      fetchPost();
    }
  };

  const handleReportPost = async () => {
    const obj = {
      post_id: blockReportIDs,
      comment: reportComment,
    };
    const res = await reportPostApi(obj);
    if (res?.data?.status == 200) {
      setIsBlockOpen(false);
      setPostType("");
      setBlockReportIDs("");
      fetchPost();
    }
    // console.log(res, "res-report");
  };

  const handleBlock = (id, type) => {
    setBlockReportIDs(id);
    setIsBlockOpen(true);
    setPostType(type);
  };
  const handleReport = (id, type) => {
    setBlockReportIDs(id);
    setIsBlockOpen(true);
    setPostType(type);
  };

  const fetchMorePost = async () => {
    try {
      setLoadMore(true);
      const body = { user_id: id, post_status: 2, page: page };
      const response = await getPaidPost(body);
      if (response?.data?.data?.data.length > 0) {
        setPosts((prevPosts) => [...prevPosts, ...response.data.data.data]);
        setPage((pagePre) => pagePre + 1);
        setLoadMore(false);
      } else {
        setHasMore(false);
        setLoadMore(false);
      }
    } catch (error) {
      console.error("Error fetching more data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const toggleDropdown = (index) => {
    // Copy the current states
    const newDropdownStates = [...dropdownStates];
    // If the index is out of bounds (e.g., first render), initialize it as false
    if (newDropdownStates.length <= index) {
      newDropdownStates[index] = false; // Initialize as closed
    }
    // Toggle the state
    newDropdownStates[index] = !newDropdownStates[index];
    // Update the state with the new array
    setDropdownStates(newDropdownStates);
  };

  useEffect(() => {
    if (!isDataFeteched) fetchPost();
  }, [isDataFeteched]);

  const fetchPost = async () => {
    try {
      setLoader(true);
      const body = { user_id: id, post_status: 2, page: 1 };
      const response = await getPaidPost(body);
      if (response?.data?.data?.data.length > 0) {
        // setPage(page + 1);
        setisDataFeteched(true);
        setPosts(response.data.data.data);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    let user_id = localStorage.getItem("user_id");
    setLoginUserId(user_id);
  }, []);

  const fetchPostNotification = async (id) => {
    try {
      const response = await getMyPost({ post_id: id });
      if (response?.data?.data?.data.length > 0) {
        setisDataFeteched(true);
        setPosts(response.data.data.data);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error:", error);
    }
  };

  // useEffect(() => {
  //   const postIdToScroll = postId;
  //   if (postIdToScroll) {
  //     setCommentOpenStates((prevStates) => ({
  //       ...prevStates,
  //       [postIdToScroll]: true,
  //     }));
  //     fetchPostNotification(postIdToScroll);
  //   }
  // }, [posts]);

  const [loadingComment, setLoadingComment] = useState(false);

  const handleCommentToggle = async (index, id, isOpen) => {
    setLoadingComment(true);
    try {
      isOpen = isOpen !== undefined ? isOpen : !commentOpenStates[index];

      if (!isOpen) {
        setCommentOpenStates((prevStates) => ({
          ...prevStates,
          [index]: false,
        }));
        return;
      }
      const response = await getComment(id);
      if (response?.status == 200) {
        setTimeout(() => {
          setLoadingComment(false);
        }, 1000);
        setCommentOpenStates((prevStates) => {
          const newState = {};
          Object.keys(prevStates).forEach((key) => {
            newState[key] = false;
          });
          return newState;
        });

        const sortedChats = response?.data?.data.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );

        setPostComments((prevComments) => ({
          ...prevComments,
          [id]: sortedChats,
        }));

        setCommentOpenStates((prevStates) => ({
          ...prevStates,
          [index]: isOpen,
        }));
      }
    } catch (error) {
      setTimeout(() => {
        setLoadingComment(false);
      }, 1000);
      console.error("Error fetching comments:", error);
    }
  };

  const handleAddComment = async (postId, index) => {
    // console.log(postId, "postId++++++++++");
    setIsDisabled(true);

    const body = {
      post_id: postId,
      comment: newComment,
    };
    try {
      const response = await addComment(body);
      // console.log(response, "res");
      if (response.status === 200) {
        // fetchPost();
        await getComment(postId);
        handleCommentToggle(index, postId, true);
        setIsDisabled(false);
        setCommentOpenStates((prevStates) => ({
          ...prevStates,
          [postId]: false,
        }));
        setNewComment("");
        setIsDisabled(false);
      }
      if (!response.ok) {
        setIsDisabled(false);
        throw new Error("Failed to add a comment");
      }
    } catch (error) {
      console.error(error);
      setIsDisabled(false);
      // Handle error
    }
  };

  function calculateTimeAgo(created_at) {
    const currentDate = new Date();
    const createdAtDate = new Date(created_at);

    // Ensure time difference is non-negative
    const timeDifference = Math.max(
      0,
      currentDate.getTime() - createdAtDate.getTime()
    );

    const secondsInMs = 1000;
    const minutesInMs = secondsInMs * 60;
    const hoursInMs = minutesInMs * 60;
    const daysInMs = hoursInMs * 24;
    const monthsInMs = daysInMs * 30; // Note: Approximation, as months have varying numbers of days
    const yearsInMs = daysInMs * 365; // Note: Does not account for leap years

    if (timeDifference < secondsInMs) {
      return "just now";
    } else if (timeDifference < minutesInMs) {
      return Math.round(timeDifference / secondsInMs) + "s ago";
    } else if (timeDifference < hoursInMs) {
      return Math.round(timeDifference / minutesInMs) + "m ago";
    } else if (timeDifference < daysInMs) {
      return Math.round(timeDifference / hoursInMs) + "h ago";
    } else if (timeDifference < monthsInMs) {
      return Math.round(timeDifference / daysInMs) + "d ago";
    } else if (timeDifference < yearsInMs) {
      // Change 'm' to 'mo' to avoid confusion with 'minutes'
      return Math.round(timeDifference / monthsInMs) + "mo ago";
    } else {
      return Math.round(timeDifference / yearsInMs) + "y ago";
    }
  }

  const handleLikeDislike = async (postId) => {
    const postssss = posts.map((val) => {
      if (!val?.repost?.id && val?.id == postId) {
        val.is_like_by_me = !val.is_like_by_me;
        val.total_likes =
          val.is_like_by_me == true ? val.total_likes + 1 : val.total_likes - 1;
      } else if (val?.repost?.id == postId) {
        val.repost.is_like_by_me = !val.repost.is_like_by_me;
        val.repost.total_likes =
          val.repost.is_like_by_me == true
            ? val.repost.total_likes + 1
            : val.repost.total_likes - 1;
      }
      return val;
    });
    setPosts(postssss);

    setIsDisabled(true);
    try {
      const response = await likeDislike(postId);
      // console.log(response, "res");
      if (response.status === 200) {
        // fetchPost();
        setLoading(false);
        setIsDisabled(false);
      }
      if (response.status !== 200) {
        setIsDisabled(false);
        const postssss = posts.map((val) => {
          if (val?.id == postId) {
            val.is_like_by_me = false;
            val.total_likes = val.total_likes > 0 ? val.total_likes - 1 : 0;
          } else if (val?.repost?.id == postId) {
            val.repost.is_like_by_me = false;
            val.repost.total_likes =
              val.repost.total_likes > 0 ? val.repost.total_likes - 1 : 0;
          }
          return val;
        });
        setPosts(postssss);
        throw new Error("Failed to update like/dislike status");
      }
    } catch (error) {
      const postssss = posts.map((val) => {
        if (val?.id == postId) {
          val.is_like_by_me = false;
          val.total_likes = val.total_likes > 0 ? val.total_likes - 1 : 0;
        } else if (val?.repost?.id == postId) {
          val.repost.is_like_by_me = false;
          val.repost.total_likes =
            val.repost.total_likes > 0 ? val.repost.total_likes - 1 : 0;
        }
        return val;
      });
      setPosts(postssss);
      setIsDisabled(false);
      console.error(error);
    }
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleDeletePost = async (postId) => {
    // console.log(postId);
    handleOpenModal();
    setNewId(postId);
  };
  const handleDelete = async () => {
    try {
      const response = await deletePost(newid);
      if (response.status === 200) {
        setPosts((prevPosts) => prevPosts.filter((post) => post.id !== newid));
        // toast.success("Post deleted successfully");
        fetchPost();
        handleCloseModal();
      } else {
        throw new Error("Failed to delete the post");
      }
    } catch (error) {
      console.error(error);
      // Handle error
    }
  };
  const handleEditClick = (postId) => {
    // Navigate to the edit post page with the post ID
    navigate(`/edit-post/${postId}`);
  };

  const handleDeleteComment = async (id) => {
    setIsDisabled(true);
    try {
      // const isConfirmed = window.confirm("Are you sure you want to delete this post?");
      // if (isConfirmed) {
      // Make API call to delete the post
      const response = await deleteComment(id); // You need to implement this function

      if (response.status === 200) {
        // Remove the deleted post from the state

        // toast.success("Comment deleted successfully");
        fetchPost();
        handleCommentToggle(true);
        setLoading(false);
        setIsDisabled(false);
      } else {
        setIsDisabled(false);
        throw new Error("Failed to delete the post");
        toast.error("Failed to delete the post");
      }
      // }
    } catch (error) {
      setIsDisabled(false);
      console.error(error);
      // Handle error
    }
  };

  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  const [postUndo, setPostUndo] = useState(false);

  const [postUndoId, setPostUndoID] = useState("");

  const handleUndoRepost = async () => {
    try {
      const res = await undoRepostPost(postUndoId);
      if (res.status === 200) {
        fetchPost();
        setPostUndo(false);
        setIsDisabled(false);
      }
      if (!res.ok) {
        setIsDisabled(false);
      }
    } catch (error) {
      setIsDisabled(false);
      console.error(error);
    }
  };
  const handleUndoCancel = () => {
    setPostUndo(false);
  };

  const handleRepost = async (postId, userId, id) => {
    console.log(userId == loginUserId, "userId");
    if (userId == loginUserId) {
      setPostUndoID(id);
      setPostUndo(true);
    } else {
      setIsDisabled(true);
      try {
        const response = await repostPost(postId);
        if (response.status === 200) {
          fetchPost();
          setIsDisabled(false);
        }
        if (!response.ok) {
          setIsDisabled(false);
          throw new Error("Failed to update like/dislike status");
        }
      } catch (error) {
        setIsDisabled(false);
        console.error(error);
      }
    }
  };

  const handleSavePost = async (postId) => {
    const postssss = posts.map((val) => {
      if (!val?.repost?.id && val?.id == postId) {
        val.is_saved = !val.is_saved;
      } else if (val?.repost?.id == postId) {
        val.repost.is_saved = !val.repost.is_saved;
      }
      return val;
    });
    setPosts(postssss);
    // console.log(postId);
    setIsDisabled(true);
    try {
      // Make API call to update like/dislike status
      const response = await savePost(postId);
      // console.log(response, "res");
      if (response.status === 200) {
        // toast.success(response.data.message);
        fetchPost();
        setIsDisabled(false);
      }
      if (response.status !== 200) {
        setIsDisabled(false);
        const postssss = posts.map((val) => {
          if (val?.id == postId) {
            val.is_saved = false;
          } else if (val?.repost?.id == postId) {
            val.repost.is_saved = false;
          }
          return val;
        });
        setPosts(postssss);
        throw new Error("Failed to save post");
      }
    } catch (error) {
      setIsDisabled(false);
      console.error(error);
      // Handle error
    }
  };
  const isMobileView = document.body.clientWidth <= 768; // You can adjust the breakpoint as needed
  // const scrollToPost = (postId) => {
  //   const postElement = document.getElementById(postId);
  //   if (postElement) {
  //     postElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //   }
  // };
  // const renderDescriptionWithLineBreaks = (description) => {
  //   // Split by triple line break first to handle the largest distinct pattern
  //   const tripleSplit = description.split('\n\n\n').map((block, blockIndex) => (
  //     <React.Fragment key={`block-${blockIndex}`}>
  //       {blockIndex > 0 && <><br /><br /></>} {/* Add two line breaks for \n\n\n except before the first block */}
  //       {
  //         // Split by double line break within each block
  //         block.split('\n\n').map((paragraph, paragraphIndex, paragraphArray) => (
  //           <React.Fragment key={`paragraph-${paragraphIndex}`}>
  //             {paragraphIndex > 0 && <br />} {/* Add one line break for \n\n except before the first paragraph */}
  //             {
  //               // Split by single line break within each paragraph
  //               paragraph.split('\n').map((line, lineIndex) => (
  //                 <p key={`line-${lineIndex}`}>{line}</p>
  //               ))
  //             }
  //           </React.Fragment>
  //         ))
  //       }
  //     </React.Fragment>
  //   ));

  //   return tripleSplit;
  // };
  const renderDescriptionDynamicLineBreaks = (description) => {
    // Check if description is null or undefined
    if (!description || description == null) {
      return null;
    }

    // Regular expression to match one or more newline characters
    const regex = /(\n+)/g;

    // Split the description by the regex, keeping the delimiter
    const parts = description.split(regex);

    return parts.map((part, index) => {
      if (part.match(regex)) {
        // For newline characters, return a series of <br /> elements equal to the count of \n minus 1
        return [...Array(part.length - 1)].map((_, brIndex) => (
          <br key={`br-${index}-${brIndex}`} />
        ));
      } else {
        // For regular text, return a paragraph
        return <p key={`text-${index}`}>{part}</p>;
      }
    });
  };

  const handleShare = async (id) => {
    const urlToShare = `https://app.qushi.io/feed/${id}`;

    const shareData = {
      title: "QUSHI",
      text: "Check out this!",
      url: urlToShare,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
        // console.log("Data was shared successfully");
      } else {
        const shareLinkPrompt = `Share this link: ${urlToShare}`;
        alert(shareLinkPrompt);
      }
    } catch (err) {
      console.error("Error sharing:", err);
    }
  };

  const [preview, setPreview] = useState(false);
  const [activeImage, setActiveImage] = useState("");

  // Function to open the preview modal
  const showPreview = (image) => {
    setActiveImage(image);
    setPreview(true);
  };

  const videoExtensionsRegex = /\.(mp4|mov|avi|wmv)$/i;

  const [isPreviewVideo, setIsPreviewVideo] = useState(false);
  const [attachments, setAttachments] = useState("");

  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);

  const [showVideos, setShowVideos] = useState(
    new Array(posts?.length).fill(false)
  );

  const handlePlayClick = (index) => {
    const video = document.querySelector(`#video-${index}`);
    const playButton = document.querySelector(`#play-button-${index}`);

    if (currentVideoIndex !== null && currentVideoIndex !== index) {
      const currentVideo = document.querySelector(
        `#video-${currentVideoIndex}`
      );
      currentVideo.pause();
    }

    if (video?.paused) {
      video.play();
      setCurrentVideoIndex(index);
      playButton.style.display = "none";

      video.onended = () => {
        playButton.style.display = "block";
      };
    } else {
      video.pause();
      playButton.style.display = "block";
      setCurrentVideoIndex(null);
    }
  };

  const handleVideoClick = (index) => {
    const updatedShowVideos = [...showVideos];
    updatedShowVideos[index] = !updatedShowVideos[index];
    setShowVideos(updatedShowVideos);
  };

  const videoRefs = useRef([]);

  const getVideoThumbnail = (videoUrl) => {
    const video1 = videoUrl + ".jpg";
    return video1;
  };

  const handleCloseVideoClick = () => {
    setIsPreviewVideo(false);
    setAttachments("");
  };

  return (
    <div>
      <DashboardHeader
        toggle={sidebarToggle}
        avatar={profile?.image}
        user={{ name: profile?.full_name }}
        setStocksData={setPosts}
        setLoader={setLoader}
        endMessage={
          <p style={{ textAlign: "center" }}>
            <b>Yay! You have seen it all</b>
          </p>
        }
      />
      <PageContainer>
        <div className="md:block  rounded-2xl bg-white max-w-[60rem] mx-auto">
          <div className="flex flex-col md:px-4 px-0  bg-white md:rounded-xl md:shadow-lg md:mx-2 py-2">
            <div className="w-full flex items-center justify-center md:mt-24 mt-[72px]"></div>
            {/* <div className="w-full mt-3 h-px bg-gray-300"></div>{" "} */}
            {/* Full width line separator */}
            <div className="bg-white">
              <main className="h-full bg-#fbfcfc pt-4  justify-center">
                <InfiniteScroll
                  dataLength={posts.length}
                  next={posts.length > 9 && fetchMorePost}
                  hasMore={hasMore}
                  loader={loadMore && <SmallLoader />}
                  style={{
                    overflow: "hidden",
                  }}
                  endMessage={
                    <p style={{ textAlign: "center" }}>
                      <b>Yay! You have seen it all</b>
                    </p>
                  }
                >
                  {posts.length == 0 && loader ? (
                    <Loader dark />
                  ) : !loader && posts.length > 0 ? (
                    posts.map((post, index) => {
                      return (
                        <div
                          key={index}
                          className="text-white p-2 flex flex-col"
                          id={post?.repost?.id ? post?.repost?.id : post?.id}
                        >
                          {post?.repost?.id && (
                            <div className="mt-4 text-black">
                              <div className="flex items-center mb-2 ml-0 md:ml-12">
                                {/* Display repost information here */}
                                <FontAwesomeIcon
                                  className="text-primaryColor mr-2"
                                  icon={faRepeat}
                                />
                                <p
                                  className="text-lg font-bold whitespace-nowrap"
                                  style={{ color: "#004c50" }}
                                >
                                  {post?.user?.user_name} Reposted{" "}
                                </p>
                              </div>
                            </div>
                          )}
                          <div className="flex items-center mb-2 justify-between">
                            <div className="flex items-center">
                              <Link
                                to={
                                  post?.repost?.user?.id &&
                                    loginUserId != post?.repost?.user?.id
                                    ? `/profile/${post?.repost?.user?.id}`
                                    : post?.repost?.user?.id == loginUserId
                                      ? "/profile"
                                      : loginUserId == post?.user?.id
                                        ? "/profile"
                                        : `/profile/${post?.user?.id}`
                                }
                                className={isMobileView ? "w-10" : ""}
                              >
                                <img
                                  src={
                                    post?.repost?.id
                                      ? post?.repost?.user?.image
                                      : post?.user?.image
                                  }
                                  alt="profile"
                                  className={`rounded-full ${isMobileView
                                    ? "h-10 w-full mr-0  object-cover"
                                    : "h-10 w-10  mr-2 object-cover"
                                    }`}
                                />
                              </Link>
                              {/* <Link
                                to={
                                  post?.repost?.user?.id &&
                                  loginUserId != post?.repost?.user?.id
                                    ? `/profile/${post?.repost?.user?.id}`
                                    : post?.repost?.user?.id == loginUserId
                                    ? "/profile"
                                    : loginUserId == post?.user?.id
                                    ? "/profile"
                                    : `/profile/${post?.user?.id}`
                                }
                              >
                                <span
                                  className={
                                    isMobileView
                                      ? "text-[14px] ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                      : "px-1 ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                  }
                                >
                                  {post?.repost?.id
                                    ? post?.repost?.user?.user_name
                                    : post?.user?.user_name}
                                </span>
                              </Link> */}


                              <span
                                className={
                                  isMobileView
                                    ? "px-1 text-[19px] sm:ml-[0] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                    : "px-1  sm:ml-[0] text-[20px] text-black font-bold font-poppins whitespace-nowrap"
                                }
                              >
                                {/* @QUSHI */}@
                                {post?.repost?.id
                                  ? post?.repost?.user?.user_name
                                  : post.user.user_name}
                              </span>
                              {post?.user?.green_tick ? (
                                <img
                                  src={GreenTick}
                                  alt="green-tick"
                                  className="object-cover"
                                />
                              ) : // <FontAwesomeIcon icon={faCheckCircle} className="px-1 text-xl md:text-2xl text-primaryColor" />
                                null}
                            </div>
                            <div className="flex items-center justify-between ">
                              <div>
                                <span
                                  className={
                                    isMobileView
                                      ? "mr-4 text-[12px] whitespace-nowrap text-gray-600 font-poppins"
                                      : "mr-4 text-[13px] whitespace-nowrap text-gray-600 font-poppins"
                                  }
                                >
                                  {calculateTimeAgo(
                                    post?.repost?.id
                                      ? post?.repost?.created_at
                                      : post.created_at
                                  )}
                                </span>
                              </div>
                              {post?.user?.id == loginUserId ? (
                                <div
                                  className={
                                    isMobileView
                                      ? "relative inline-block text-left"
                                      : "relative inline-block mr-2 text-left"
                                  }
                                >
                                  <button
                                    onClick={() => toggleDropdown(index)}
                                    type="button"
                                    className={
                                      isMobileView
                                        ? "w-full bg-white-400 text-[12px]  text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                        : "w-full bg-white-400 text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={
                                        isMobileView ? faEllipsisV : faEllipsisH
                                      }
                                    />
                                  </button>
                                  {dropdownStates[index] && (
                                    <div className="origin-top-right text-green-500 absolute right-1 mt-0 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 mr-[-10px]">
                                      <button
                                        onClick={() =>
                                          handleDeletePost(post.id)
                                        }
                                        className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon
                                            className="mr-1"
                                            icon={faTrash}
                                          />{" "}
                                          Delete Post
                                        </div>
                                      </button>
                                      <button
                                        onClick={() =>
                                          handleEditClick(
                                            post?.repost?.id
                                              ? post?.repost?.id
                                              : post.id
                                          )
                                        }
                                        className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                      >
                                        <div className="flex flex-row justify-center items-center">
                                          <FontAwesomeIcon
                                            className="mr-1"
                                            icon={faEdit}
                                          />{" "}
                                          Edit Post
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div
                                  className={
                                    isMobileView
                                      ? "relative inline-block text-left"
                                      : "relative inline-block mr-2 text-left"
                                  }
                                >
                                  <button
                                    onClick={() => toggleDropdown(index)}
                                    type="button"
                                    className={
                                      isMobileView
                                        ? "z-50 w-full bg-white-400 text-[12px]  text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                        : "z-50 w-full bg-white-400 text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={
                                        isMobileView ? faEllipsisV : faEllipsisH
                                      }
                                    />
                                  </button>
                                  {dropdownStates[index] && (
                                    <div className="z-50 origin-top-right text-green-500 absolute right-1 mt-0 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 mr-[-10px]">
                                      <button
                                        className="block text-primaryColor w-full -ml-1 px-2 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                        onClick={() =>
                                          handleBlock(
                                            post?.repost?.id
                                              ? post?.repost?.user?.id
                                              : post?.user?.id,
                                            "block"
                                          )
                                        }
                                      >
                                        <div className="">
                                          <FontAwesomeIcon
                                            className="h-3 mr-1"
                                            icon={faBan}
                                          />{" "}
                                          Block User
                                        </div>
                                      </button>
                                      <button
                                        className="block w-full text-primaryColor px-2.5 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem"
                                        onClick={() =>
                                          handleReport(
                                            post?.repost?.id
                                              ? post?.repost?.id
                                              : post.id,
                                            "report"
                                          )
                                        }
                                      >
                                        <div className="">
                                          <FontAwesomeIcon
                                            className="h-3 mr-2"
                                            icon={faFlag}
                                          />
                                          Report Post
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="ml-5 px-0 my-2 sm:px-10 font-poppins">
                            {post?.repost?.id ? (
                              <div className="text-[14px] font-poppins text-[#707070]">
                                {showFullRepostDescription[index]
                                  ? renderDescriptionDynamicLineBreaks(
                                    post?.repost?.description
                                  )
                                  : post?.repost?.description?.length > 255
                                    ? renderDescriptionDynamicLineBreaks(
                                      post?.repost?.description.substring(
                                        0,
                                        255
                                      )
                                    )
                                    : renderDescriptionDynamicLineBreaks(
                                      post?.repost?.description
                                    )}
                                {post?.repost?.description &&
                                  post?.repost?.description.length > 255 && (
                                    <button
                                      onClick={() => {
                                        setShowFullRepostDescription(
                                          (prevState) => {
                                            const newState = [...prevState];
                                            newState[index] = !newState[index];
                                            return newState;
                                          }
                                        );
                                      }}
                                      className="text-green-500 ml-1"
                                    >
                                      {showFullRepostDescription[index]
                                        ? "Show less"
                                        : "Show more"}
                                    </button>
                                  )}
                              </div>
                            ) : (
                              <div className=" text-[14px] font-poppins text-[#707070]">
                                {showFullDescription[index]
                                  ? renderDescriptionDynamicLineBreaks(
                                    post?.description
                                  )
                                  : post?.description?.length > 255
                                    ? renderDescriptionDynamicLineBreaks(
                                      post?.description.substring(0, 255)
                                    )
                                    : renderDescriptionDynamicLineBreaks(
                                      post?.description
                                    )}
                                {post?.description &&
                                  post?.description.length > 255 && (
                                    <button
                                      onClick={() => {
                                        setShowFullDescription((prevState) => {
                                          const newState = [...prevState];
                                          newState[index] = !newState[index];
                                          return newState;
                                        });
                                      }}
                                      className={"text-green-500 ml-1"}
                                    >
                                      {showFullDescription[index]
                                        ? "Show less"
                                        : "Show more"}
                                    </button>
                                  )}
                              </div>
                            )}
                          </div>
                          <div
                            className={
                              isMobileView
                                ? "ml-12  flex px-0 my-2 sm:px-10 flex-wrap"
                                : "ml-5  flex px-0 my-2 sm:px-10 flex-wrap"
                            }
                          >
                            {post?.repost?.id
                              ? post?.repost?.post_image.map(
                                (image, imageIndex) => (
                                  <div key={imageIndex} className="mr-2 mb-2">
                                    {videoExtensionsRegex.test(
                                      image.image
                                    ) ? (
                                      <div
                                        className={
                                          post?.repost?.post_image.length == 1
                                            ? isMobileView
                                              ? "w-[300px] h-[350px] relative rounded-lg"
                                              : "w-[780px] h-[400px] relative rounded-lg"
                                            : isMobileView
                                              ? "w-[300px] h-[300px] relative rounded-lg"
                                              : "w-[385px] h-[300px] relative rounded-lg"
                                        }
                                      >
                                        {!showVideos[index] ? (
                                          <div>
                                            <img
                                              src={getVideoThumbnail(
                                                image.image
                                              )}
                                              id={`image-${index}`}
                                              className={
                                                post?.repost?.post_image
                                                  .length == 1
                                                  ? isMobileView
                                                    ? "w-[350px] h-[350px] object-contain rounded-lg "
                                                    : "w-[780px] h-[400px] object-contain rounded-lg "
                                                  : isMobileView
                                                    ? "w-[350px] h-[340px] object-contain rounded-lg "
                                                    : "w-[385px] h-[300px] object-contain rounded-lg "
                                              }
                                              alt="Video Thumbnail"
                                              onClick={(e) => {
                                                handleVideoClick(index);
                                              }}
                                            />
                                          </div>
                                        ) : (
                                          <video
                                            ref={(el) =>
                                              (videoRefs.current[index] = el)
                                            }
                                            autobuffer
                                            playsInline={true}
                                            webkit-playsinline="true"
                                            x5-playsinline="true"
                                            x-webkit-airplay="deny"
                                            disablePictureInPicture={true}
                                            controlsList="nodownload"
                                            onContextMenu={(e) =>
                                              e.preventDefault()
                                            }
                                            controls
                                            autoPlay
                                            id={`video-${index}`}
                                            preload="auto"
                                            className="w-full h-full object-contain rounded-lg"
                                            onLoadedMetadata={(e) => {
                                              if (isMobileView) {
                                                e.target.currentTime = 1;
                                              }
                                            }}
                                          >
                                            <source src={image.image} />
                                          </video>
                                        )}
                                        <button
                                          id={`play-button-${index}`}
                                          className="absolute inset-0 flex rounded-lg items-center bg-black justify-center bg-opacity-50 text-white"
                                          style={{
                                            display: showVideos[index]
                                              ? "none"
                                              : "block",
                                          }}
                                          onClick={() => {
                                            handleVideoClick(index);
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            className="h-7"
                                            icon={faPlay}
                                          />
                                        </button>
                                      </div>
                                    ) : (
                                      <img
                                        onClick={() =>
                                          showPreview(image.image)
                                        }
                                        src={image?.image}
                                        alt={`Post_Image ${imageIndex + 1}`}
                                        className={
                                          post?.repost?.post_image.length == 1
                                            ? isMobileView
                                              ? "w-[350px] h-[200px] object-cover rounded-lg "
                                              : "w-[780px] h-[400px] object-cover rounded-lg "
                                            : isMobileView
                                              ? "w-[350px] h-[200px] object-cover rounded-lg "
                                              : "w-[385px] h-[300px] object-cover rounded-lg "
                                        }
                                      />
                                    )}
                                  </div>
                                )
                              )
                              : post.post_image.map((image, imageIndex) => (
                                <div key={imageIndex} className="mr-2 mb-2">
                                  {videoExtensionsRegex.test(image.image) ? (
                                    <div
                                      className={
                                        post?.post_image.length == 1
                                          ? isMobileView
                                            ? "w-[300px] h-[350px] relative rounded-lg"
                                            : "w-[780px] h-[400px] relative rounded-lg"
                                          : isMobileView
                                            ? "w-[300px] h-[300px] relative rounded-lg"
                                            : "w-[385px] h-[300px] relative rounded-lg"
                                      }
                                    >
                                      {!showVideos[index] ? (
                                        <div>
                                          <img
                                            src={getVideoThumbnail(
                                              image.image
                                            )}
                                            id={`image-${index}`}
                                            className={
                                              post?.post_image.length == 1
                                                ? isMobileView
                                                  ? "w-[350px] h-[350px] object-contain rounded-lg "
                                                  : "w-[780px] h-[400px] object-contain rounded-lg "
                                                : isMobileView
                                                  ? "w-[350px] h-[340px] object-contain rounded-lg "
                                                  : "w-[385px] h-[300px] object-contain rounded-lg "
                                            }
                                            alt="Video Thumbnail"
                                            onClick={(e) => {
                                              handleVideoClick(index);
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        <video
                                          ref={(el) =>
                                            (videoRefs.current[index] = el)
                                          }
                                          autobuffer
                                          playsInline={true}
                                          webkit-playsinline="true"
                                          x5-playsinline="true"
                                          x-webkit-airplay="deny"
                                          disablePictureInPicture={true}
                                          controlsList="nodownload"
                                          onContextMenu={(e) =>
                                            e.preventDefault()
                                          }
                                          controls
                                          autoPlay
                                          id={`video-${index}`}
                                          preload="auto"
                                          className="w-full h-full object-contain rounded-lg"
                                          onLoadedMetadata={(e) => {
                                            if (isMobileView) {
                                              e.target.currentTime = 1;
                                            }
                                          }}
                                        >
                                          <source src={image.image} />
                                        </video>
                                      )}
                                      <button
                                        id={`play-button-${index}`}
                                        className="absolute inset-0 flex rounded-lg items-center justify-center bg-black bg-opacity-50 text-white"
                                        style={{
                                          display: showVideos[index]
                                            ? "none"
                                            : "block",
                                        }}
                                        onClick={() => {
                                          handleVideoClick(index);
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          className="h-7"
                                          icon={faPlay}
                                        />
                                      </button>
                                    </div>
                                  ) : (
                                    <img
                                      onClick={() => showPreview(image.image)}
                                      src={image.image}
                                      alt={`Post_Image ${imageIndex + 1}`}
                                      className={
                                        post?.post_image.length == 1
                                          ? isMobileView
                                            ? "w-[350px] h-[200px] object-cover rounded-lg "
                                            : "w-[780px] h-[400px] object-cover rounded-lg "
                                          : isMobileView
                                            ? "w-[350px] h-[200px] object-cover rounded-lg "
                                            : "w-[385px] h-[300px] object-cover rounded-lg "
                                      }
                                    />
                                  )}
                                </div>
                              ))}

                            {preview && (
                              <div
                                style={{
                                  position: "fixed",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                                  opacity: "1",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  zIndex: 1000, // Set a higher value to ensure it's above the sidebar
                                }}
                                onClick={() => setPreview(false)}
                              >
                                <TransformWrapper
                                  defaultScale={1}
                                  defaultPositionX={200}
                                  defaultPositionY={100}
                                  className="flex items-center justify-center"
                                >
                                  {({
                                    zoomIn,
                                    zoomOut,
                                    resetTransform,
                                    positionX,
                                    positionY,
                                    ...rest
                                  }) => (
                                    <>
                                      <TransformComponent className="flex items-center justify-center">
                                        <img
                                          src={activeImage}
                                          alt="Preview"
                                          className={
                                            isMobileView ? "ml-3" : "ml-6"
                                          }
                                          style={{
                                            maxWidth: "95%",
                                            maxHeight: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      </TransformComponent>
                                    </>
                                  )}
                                </TransformWrapper>
                              </div>
                            )}
                          </div>
                          <div className="flex flex-row md:ml-8 ml-[2.8rem] justify-between items-center px-4 sm:px-8 my-4 text-green-500 space-x-4">
                            <button
                              onClick={() =>
                                handleCommentToggle(
                                  index,
                                  post?.repost?.id ? post?.repost?.id : post.id
                                )
                              }
                              className="flex flex-row justify-center items-center"
                            >
                              <FontAwesomeIcon icon={empty2} />
                              <p className="ml-1 md:text-xs text-xxs">
                                {post?.repost?.id
                                  ? post?.repost?.total_comments
                                  : post.total_comments}
                              </p>
                            </button>
                            <button
                              disabled={isDisabled ? true : false}
                              onClick={() =>
                                handleRepost(
                                  post?.repost?.id ? post?.repost?.id : post.id,
                                  post?.repost?.id ? post.user_id : "",
                                  post.id
                                )
                              }
                              className="flex flex-row justify-center items-center "
                            >
                              <FontAwesomeIcon icon={faRepeat} />
                              <p className="ml-1 md:text-xs text-xxs">
                                {post?.repost?.id
                                  ? post?.repost?.repost_count
                                  : post.repost_count}
                              </p>
                            </button>
                            <button
                              disabled={isDisabled ? true : false}
                              onClick={() =>
                                handleLikeDislike(
                                  post?.repost?.id ? post?.repost?.id : post.id,
                                  post.total_likes
                                )
                              }
                              className="flex flex-row justify-center items-center"
                            >
                              {post?.repost?.id ? (
                                <FontAwesomeIcon
                                  icon={
                                    post?.repost?.is_like_by_me
                                      ? faHeart
                                      : empty
                                  }
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={post?.is_like_by_me ? faHeart : empty}
                                />
                              )}

                              <p className="ml-1 md:text-xs text-xxs">
                                {post?.repost?.id
                                  ? post?.repost?.total_likes
                                  : post.total_likes}
                              </p>
                            </button>

                            <button
                              disabled={isDisabled ? true : false}
                              onClick={() =>
                                handleSavePost(
                                  post?.repost?.id ? post?.repost?.id : post.id
                                )
                              }
                              className="flex flex-row justify-center items-center "
                            >
                              {post?.repost?.id ? (
                                <FontAwesomeIcon
                                  icon={
                                    post?.repost?.is_saved ? saved : faBookmark
                                  }
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={post.is_saved ? saved : faBookmark}
                                />
                              )}
                            </button>
                            {isModalOpen && (
                              <div
                                className={
                                  isMobileView
                                    ? "fixed top-0 left-0 h-full flex items-center justify-center right-5"
                                    : "fixed top-0 left-0 w-full h-full flex items-center justify-center"
                                }
                              >
                                <div className="bg-white p-6 rounded shadow-lg text-center">
                                  {/* Modal content goes here */}
                                  <div className="flex justify-center items-center my-2">
                                    <img
                                      src={"/qushi_logo.png"}
                                      className="h-24"
                                      alt="logo"
                                    />
                                  </div>
                                  <p className="mb-4 text-primaryColor">
                                    Are you sure you want to delete this post?
                                  </p>
                                  <div className="flex justify-center">
                                    <button
                                      disabled={isDisabled ? true : false}
                                      onClick={handleDelete}
                                      className="bg-primaryColor text-white py-2 px-4 rounded mr-2"
                                    >
                                      Delete Post
                                    </button>
                                    <button
                                      onClick={handleCloseModal}
                                      className="bg-red-500 text-white py-2 px-4 rounded"
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}

                            <button
                              onClick={() =>
                                handleShare(
                                  post?.repost?.id ? post?.repost?.id : post.id
                                )
                              }
                              className="flex flex-row justify-center items-center"
                            >
                              <FontAwesomeIcon icon={faArrowUpFromBracket} />
                            </button>
                          </div>
                          {commentOpenStates[index] && (
                            <div className="mt-4 text-black ml-[20px] md:ml-[60px] lg:ml-[60px]">
                              <div className="mt-4 space-y-2">
                                {!loadingComment &&
                                  postComments[
                                  post?.repost?.id ? post?.repost?.id : post.id
                                  ] &&
                                  postComments[
                                    post?.repost?.id ? post?.repost?.id : post.id
                                  ].length > 0 ? (
                                  postComments[
                                    post?.repost?.id
                                      ? post?.repost?.id
                                      : post.id
                                  ].map((comment) => (
                                    <div
                                      key={comment.id}
                                      className="flex items-start mb-2"
                                    >
                                      <div className="flex-shrink-0">
                                        <img
                                          src={comment?.user?.image}
                                          alt={`${comment?.user?.user_name}'s avatar`}
                                          className="w-8 h-8 rounded-full mr-2"
                                        />
                                      </div>
                                      <div className="w-full">
                                        <div className="flex justify-between mb-1">
                                          <span className="font-semibold ml-2">
                                            {comment?.user?.user_name}
                                          </span>
                                          {comment?.user.id === profile?.id && (
                                            <button
                                              disabled={
                                                isDisabled ? true : false
                                              }
                                              className="px-5 text-green-500"
                                              onClick={() =>
                                                handleDeleteComment(comment.id)
                                              }
                                            >
                                              <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                          )}
                                        </div>
                                        <div className="flex justify-between">
                                          <div className={"md:w-full w-52 ml-2"}>
                                            <p className="w-full break-words text-sm"   style={{
                                                whiteSpace: 'pre-wrap', // Ensures that spaces and newlines are preserved
                                                wordBreak: 'break-word', // Breaks long words if necessary to prevent overflow
                                              }}>
                                              {comment?.comment}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : loadingComment ? (
                                  <SmallLoader />
                                ) : (
                                  !loadingComment && (
                                    <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                                      <p>No comments yet</p>
                                    </div>
                                  )
                                )}
                              </div>
                              <div className="flex">
                                {/* <input
                                  type="text"
                                  value={newComment}
                                  onChange={(e) =>
                                    setNewComment(e.target.value)
                                  }
                                  placeholder="Add a comment..."
                                  className="p-2 border border-emerald-500 rounded w-full text-black"
                                  style={{ flex: 1 }} // Ensures the input takes up remaining space
                                /> */}
                                  <textarea
                                    value={newComment}
                                    onChange={(e) => setNewComment(e.target.value)}
                                    placeholder="Add a comment..."
                                    className="p-2 border border-emerald-500 rounded w-full text-black"
                                    style={{ flex: 1, resize: 'vertical' }} // Allows resizing vertically
                                    rows={3} // You can adjust this number
                                  />
                                <button
                                  className="ml-2 bg-primaryColor mt-2 text-gray-200 hover:bg-primaryColor hover:text-white px-2 rounded-full focus:outline-none"
                                  disabled={isDisabled ? true : false}
                                  onClick={() =>
                                    handleAddComment(
                                      post?.repost?.id
                                        ? post?.repost?.id
                                        : post.id,
                                      index
                                    )
                                  }
                                  style={{
                                    height: 30,
                                    minWidth: 84, // Set a minimum width for the button
                                  }}
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          )}
                          <div className="w-full mt-3 h-px bg-gray-300"></div>{" "}
                          {/* Full width line separator */}
                        </div>
                      );
                    })
                  ) : (
                    posts.length == 0 && (
                      <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                        <p>No posts available.</p>
                      </div>
                    )
                  )}
                </InfiniteScroll>
                {/* </div> */}
              </main>
            </div>
          </div>
        </div>
      </PageContainer>
      <BlockReportModal
        isOpen={isBlockOpen}
        type={postType}
        handleBlockUser={handleBlockUser}
        handleReportPost={handleReportPost}
        handleBlockUserCancel={handleBlockUserCancel}
      >
        <div className={postType == "block" ? "mb-4" : ""}>
          <p>
            {postType == "block"
              ? "Are you sure you want to block this user?"
              : "Are you sure you want to report this post?"}
          </p>
        </div>
        {postType == "block" ? (
          ""
        ) : (
          <div className="mt-4 mb-4">
            <textarea
              value={reportComment}
              className="w-full px-4 py-3 rounded-lg bg-gray-200"
              placeholder="please enter comment here..."
              onChange={(e) => setReportComment(e.target.value)}
            />
          </div>
        )}
      </BlockReportModal>
      <UndoRepostModal
        isOpen={postUndo}
        handleUndoRepost={handleUndoRepost}
        handleUndoCancel={handleUndoCancel}
      >
        <div className={"mb-4"}>
          <p>{"Are you sure you want to undo this reposted post?"}</p>
        </div>
      </UndoRepostModal>
      {isPreviewVideo && (
        <PreviewVideo src={attachments} onClick={handleCloseVideoClick} />
      )}
    </div>
  );
};

export default PaidContent;
